export function getCopyrightDate(): string {
  const currentYear = new Date().getFullYear()
  const copyrightDate =
    Number(currentYear) - 2021 > 0 ? `2021 - ${currentYear}` : currentYear.toString()

  return copyrightDate
}

